import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Company } from 'app/models/company.models';

@Injectable({
  providedIn: 'root',
})
export class EmpresaService {
  empresa: Observable<Company | any>;
  headers: HttpHeaders;

  constructor(private http: HttpClient) {}

  getEmpresa(cuit: string): Observable<Company | any> {
    return this.http.get(environment.apiUrl + 'company/cuit/' + cuit);
  }

  guardarEmpresa(empresa: Company): Observable<any> {
    return this.http.post(environment.apiUrl + 'company', empresa);
  }

  getDashboard(): Observable<any> {
    return this.http.get(environment.apiUrl + 'company/dashboard');
  }

  getEmpresaConfig(): Observable<Company> {
    return this.http.get<Company>(`${environment.apiUrl}company`);
  }

  actualizarDataEmpresa(empresa: Company): Observable<Company> {
    return this.http.patch<Company>(`${environment.apiUrl}company/${empresa.id}`, empresa);
  }
}
